import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import Avatar from '@mui/material/Avatar';

const Message = ({ user, content, userid, messageid, time = "00:00", onmessagedelete }) => {
  const { globalUser, updateUser,  login } = useContext(UserContext);
  let image = findUserById(userid);
  if(image){
    image =  `data:image/jpeg;base64,${image.ProfilePhoto}`
  }

  return (
    <>
    <div className='d-flex mb-2'>
      {/* Circle with first letter and fixed background color */}
      {/* <div
        style={{
          minWidth: '30px',
          height: '30px',
          objectFit: 'cover',
          background: bgColor,
          color: '#fff', // Text color for better contrast
        }}
        className='d-flex justify-content-center align-items-center rounded-circle fw-bold'
        >
        {firstLetter}
      </div> */}
      <Avatar sx={{ width: 30, height: 30 }} alt={user} src={image} />
      {/* Message content */}
      <div
        style={{ background: '#edf0ee' }}
        className='text-start rounded ps-2 pe-2 ms-2 me-4 pb-1 pt-1'
        >
        <div style={{ fontSize: 12, userSelect:'none' }} className='fw-bold'>
          {user}
        </div>
        <div style={{ fontSize: 12 }}>{content}</div>
        <div className='d-flex justify-content-end' style={{userSelect:'none'}}>
          <p className='mb-0 text-end' style={{fontSize:10, cursor:'pointer'}}>{time}</p>
          {(userid === globalUser?.ID || globalUser?.isHost == 1) ? <p onClick={()=>onmessagedelete(messageid)} className='mb-0 text-end text-danger ms-1' style={{fontSize:10, cursor:'pointer'}}>Delete</p> : ''}
        </div>
      </div>
    </div>
    </>
  );
};

export default Message;



const findUserById = (userId) => {
  // Get live members from localStorage
  const storedMembers = localStorage.getItem("liveMembers");
  if (storedMembers) {
      // Parse the JSON string to an array
      const membersArray = JSON.parse(storedMembers);
      // Find the user by ID
      const user = membersArray.find(member => member.UserID === userId); // Assuming each member has an `id` field
      return user || null; // Return user if found, otherwise return null
  }
  return null; 
};